import React, { useState, useContext, useEffect } from "react";
import {  useHistory } from "react-router-dom";
import { MerchantStateContext } from '../../application/context/MerchantStateContext';
import { translateIfPreferedLanguageIsSpanish } from '../../../../lib/util';



export default function PreApproval() {
    // const [redirect, setRedirect] = useState(false);
    const history = useHistory();
    const [overlay, setOverlay] = useState({ offer:false, spinner: true });
    const { mainState, lang } = useContext(MerchantStateContext);
	const { opportunity__requestedAmount, opportunity__revenue, contact__creditScoreRatio, account__startDate, contact__debt} = mainState
    const { is_spanish } = lang ;
    let langPref = mainState.contact__preferred__language || 'English'

    let preApproved = {};
    preApproved.message = translateIfPreferedLanguageIsSpanish(langPref,'Congratulations,', '¡Felicitaciones! Estas pre-aprobado') //
    // preApproved.amount = 'To get your pre-approval amount please click below to proceed'
    preApproved.amount =  translateIfPreferedLanguageIsSpanish(langPref, 'To get your pre-approval amount please click below to proceed','Haz click abajo para ver tu pre-aprobacion')

    useEffect(() => {
		// Scroll to top
		window.scrollTo(0, 0); 

	},[]);


    let parsedRequestedAmount = parseInt(opportunity__requestedAmount.replace('$','').replace(/,/g,''));
    // let parsedMonthlyRevenue = parseInt(opportunity__revenue.replace('$','').replace(/,/g,''));
    let parsedMonthlyRevenue = parseInt(
        opportunity__revenue?.replace('$', '').replace(/,/g, '') || '0'
      );
    // calculate Time in Business greater than 6 months
    let today = new Date()
    let diff = (today.getTime() - new Date(account__startDate).getTime()) / 1000;
    diff /= (60 * 60 * 24 * 7 * 4); 
    let tib =  ( Math.abs(Math.round(diff)) > 6 ? true : false); //tib = time in business

    setTimeout(() => { setOverlay({ ...overlay, spinner: false }) }, 500 );

    if (tib){
        if (parsedRequestedAmount <= parsedMonthlyRevenue * 1.5 ){
            let approvedAmount = (parsedMonthlyRevenue * ( parseFloat(contact__creditScoreRatio) + parseFloat(contact__debt)))/2;
            preApproved.amount = translateIfPreferedLanguageIsSpanish(langPref, 'Pre-approval:', 'Cantidad Pre-aprobada') + ` $${approvedAmount.toLocaleString()}`;
        };
    };

    const submitPreApproval = e => {
		e.preventDefault();
        sessionStorage.setItem("mainState", JSON.stringify(mainState));
        history.push('/onboarding/merchant/business');
    };
    
    return (
        <>
            {!overlay.spinner ? 
                <div id='preApproved' className='p-2'>
                    <div className='row preApproved_header mb-4'>
                        {/* <i className="fa fa-check-circle-o" aria-hidden="true"></i> */}
                        <div className="col-12 d-flex align-items-center justify-content-center">
                            <h4 className='mb-z5 pt-4 pb-3 text-center' style={{color: '#000000', fontWeight: '400'}}>{preApproved.message}</h4> 
                        </div>
                      
                    </div>
                    <div className='row pt-4'>
                        <div className="col-12">
                            <h2 className='text-center text-md-left'>{preApproved.amount}</h2>
                            <div className='col-12 mt-5'>
                                <button id="btnPrimaryPreApprove" onClick={(e) => submitPreApproval(e) } type="submit" className="btn btn-primary inside-form d-flex justify-content-center" style={{width: '100%'}}>
                                {is_spanish  ? 
                                'Complete su Aplicación'
                                :
                                'Finish your Application'}
            
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                :
                <>
                    {/* <h4>We are want to give you the best offer..</h4> 	 */}
                    <div style={{position:'relative'}} className='spinner'>
                        <div className='loader'>   {is_spanish  ?
                        'Cargando...'
                        :
                        'Loading...'}</div>
                    </div>
                </>
            }
        </>
    );
};
